import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../../../auth/AuthProvider';
import { usePlanGate } from '../../../hooks/usePlanGate';

export const AdminSettingsSection = () => {
  const { user } = useAuth();
  const { hasFeature } = usePlanGate();

  const orgRole = (user as Record<string, unknown> | null)?.org_role;
  const isOrgAdmin = orgRole === 'admin' && hasFeature('org_admin_controls');

  if (!isOrgAdmin) {
    return <Navigate to="/settings/account" replace />;
  }

  return (
    <div className="flex-1 overflow-y-auto">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6 sm:py-8 space-y-6">
        <div className="space-y-1">
          <h1 className="text-2xl font-semibold text-neutral-900">Admin Settings</h1>
          <p className="text-sm text-neutral-600">
            Configure organization-wide settings that apply to all members.
          </p>
        </div>

        {/* Placeholder for admin settings */}
        <section className="bg-white rounded-xl shadow-sm border border-neutral-200 p-6">
          <div className="text-center py-12">
            <p className="text-sm text-neutral-600">
              Organization-wide admin settings will be available here.
            </p>
            <p className="text-xs text-neutral-500 mt-2">
              This section will include authentication settings, model & AI configuration, tools &
              features toggles, security settings, and usage limits.
            </p>
            <p className="text-xs text-neutral-500 mt-4">
              For now, please use the{' '}
              <Link to="/admin" className="text-blue-600 hover:text-blue-700 underline">
                Admin Dashboard
              </Link>{' '}
              for organization management.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};
